import { render, staticRenderFns } from "./ShortInfo.vue?vue&type=template&id=64e0229e&scoped=true"
import script from "./ShortInfo.vue?vue&type=script&lang=js"
export * from "./ShortInfo.vue?vue&type=script&lang=js"
import style0 from "./ShortInfo.vue?vue&type=style&index=0&id=64e0229e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e0229e",
  null
  
)

export default component.exports